import { ICON_COLORS } from './icons.constants'
import { IconProps } from './icons.types'

export const TalentPoolsIcon = ({
  width = 20,
  height = 16,
  primaryColor = ICON_COLORS.PRIMARY.DEFAULT,
  secondaryColor = ICON_COLORS.SECONDARY.DEFAULT,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0593 10.0813C10.65 10.9031 11 11.9094 11 13V13.5C11 13.5469 11 13.5938 10.9968 13.6406C11.7281 14.475 12.8031 15 14 15H16C18.2093 15 20 13.2094 20 11V10.5C20 9.67188 19.3281 9 18.5 9H11.5C10.8187 9 10.2406 9.45625 10.0593 10.0813ZM11.75 4.25C11.75 5.11195 12.0924 5.9386 12.7019 6.5481C13.3113 7.15759 14.138 7.5 15 7.5C15.8619 7.5 16.6886 7.15759 17.298 6.5481C17.9075 5.9386 18.25 5.11195 18.25 4.25C18.25 3.38805 17.9075 2.5614 17.298 1.9519C16.6886 1.34241 15.8619 1 15 1C14.138 1 13.3113 1.34241 12.7019 1.9519C12.0924 2.5614 11.75 3.38805 11.75 4.25Z'
        fill={secondaryColor}
      />
      <path
        d='M5 7.5C5.86195 7.5 6.6886 7.15759 7.2981 6.5481C7.90759 5.9386 8.25 5.11195 8.25 4.25C8.25 3.38805 7.90759 2.5614 7.2981 1.9519C6.6886 1.34241 5.86195 1 5 1C4.13805 1 3.3114 1.34241 2.7019 1.9519C2.09241 2.5614 1.75 3.38805 1.75 4.25C1.75 5.11195 2.09241 5.9386 2.7019 6.5481C3.3114 7.15759 4.13805 7.5 5 7.5ZM4 9C1.79063 9 0 10.7906 0 13V13.5C0 14.3281 0.671875 15 1.5 15H8.5C9.32812 15 10 14.3281 10 13.5V13C10 10.7906 8.20938 9 6 9H4Z'
        fill={primaryColor}
      />
    </svg>
  )
}
